import React from 'react';
import { Sparkles, Target, BarChart3, Lightbulb, Eye } from 'lucide-react';

const Stats = () => {
  const values = [
    {
      icon: Sparkles,
      title: "Clarity over complexity"
    },
    {
      icon: Target,
      title: "Consistency over perfection"
    },
    {
      icon: BarChart3,
      title: "Insight over isolated numbers"
    },
    {
      icon: Lightbulb,
      title: "Designed for understanding, not overwhelm"
    },
    {
      icon: Eye,
      title: "Focused on awareness, not judgment"
    }
  ];

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(20,184,166,0.05),transparent_50%)]" />
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-800 mb-4">
            Developed with Long-Term Health in Focus
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Join a growing community of users taking control of their diabetes management
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 lg:gap-6">
          {values.map((item, index) => (
            <div 
              key={index}
              className="group relative bg-gradient-to-br from-slate-50 to-teal-50/50 rounded-3xl p-6 lg:p-8 border border-slate-100 hover:border-teal-200 hover:shadow-xl hover:shadow-teal-100/50 transition-all duration-500 text-center"
            >
              {/* Icon container */}
              <div className="w-14 h-14 bg-gradient-to-br from-teal-100 to-cyan-100 rounded-2xl flex items-center justify-center mb-5 mx-auto group-hover:scale-110 transition-transform duration-300">
                <item.icon className="w-7 h-7 text-teal-600" />
              </div>

              {/* Title */}
              <h3 className="text-lg font-semibold text-slate-800 leading-snug">
                {item.title}
              </h3>

              {/* Hover accent */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-teal-400 to-cyan-400 rounded-b-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
